export default "__VITE_ASSET__4d8c57c1__"